import React, { useContext, useEffect, useState } from 'react';
import { notification } from 'antd';
import Loader from '../../../shared/loaders/Loader';
import { BookingContext } from '../../../shared/contexts/Booking.context';
import { useRouter } from 'next/router';
import { ThemeContext } from '../../../shared/contexts/Theme.context';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import { OcrScanner, OcrScannerPropTypes } from 'civitfun-ocr-ui-component';
import civitfunOcrUserDataRequest from '../../../services/civitfunOcrUserData.service';

const DOCUMENT_TYPES = {
  IDCARD: 'IDCARD',
  PASSPORT: 'PASSPORT',
  RESIDENCEPERMIT: 'RESIDENCEPERMIT',
  MIDNI: 'MIDNI',
  MEX_IDCHILD: 'MEX-IDCHILD',
  DRIVERLICENSE: 'DRIVERLICENSE',
  HEALTHINSURANCECARD: 'HEALTHINSURANCECARD',
};

let CapturerType;
let mode;
let cameraType;

export default function CivitfunOnboarding({
  visible,
  setVisible,
  nationality,
  documentType,
  selectedLanguage,
  literals,
  aliceSuccessAction,
  setLoadUserData,
}) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const {
    state: { hotelId, bookingCustomParameters },
  } = useContext(BookingContext);

  const {
    state: {
      isKiosk,
      cameraTypeAlice,
      documentCapturerTypeAlice,
      mainColor,
      secondaryColor,
      aliceAutomaticCapture,
      extraDocument,
    },
  } = useContext(ThemeContext);
  const documentCapturerType = getDocumentCapturerFromDocumentType(documentType);

  const router = useRouter();
  const checkinGuestId = router.query.checkinGuestId;

  const [loading, setLoading] = useState(true);

  let automaticCapture = true;
  if (aliceAutomaticCapture !== undefined) {
    automaticCapture = aliceAutomaticCapture;
  }

  useEffect(() => {
    CapturerType = OcrScannerPropTypes.ALLOWED_SOURCES;

    if (isKiosk) {
      switch (documentCapturerTypeAlice) {
        case 'camera':
        default:
          mode = CapturerType.CAMERA;
          break;
        case 'file':
          mode = CapturerType.FILE;
          break;
        case 'all':
          mode = CapturerType.ALL;
          break;
      }

      cameraType =
        cameraTypeAlice === 'front'
          ? OcrScannerPropTypes.CAMERA_TYPES.FRONT
          : OcrScannerPropTypes.CAMERA_TYPES.BACK;
    } else {
      mode = CapturerType.ALL;
      cameraType = OcrScannerPropTypes.CAMERA_TYPES.BACK;
    }
    setLoading(false);
  }, []);

  function isValidOcrResponse(guestData) {
    if (!guestData) return false;
    if (guestData.document_type === "MEX-IDCHILD" && guestData.name && guestData.surname) return true;
    const mandatoryFields = ['document_number', 'name', 'surname'];

    for (const field of mandatoryFields) {
      const value = guestData[field];
      
      if (!value || String(value).trim() === '' || String(value).toLowerCase() === 'null') {
        return false;
      }
    }

    return true;
  }

  function onSuccess(images) {
    setLoading(true);
    const guestExtraData = bookingCustomParameters ? bookingCustomParameters[checkinGuestId] : {};
    civitfunOcrUserDataRequest(
      hotelId,
      selectedLanguage,
      checkinGuestId,
      documentType,
      guestExtraData,
      images
    )
      .then(response => {
        const guestData = response?.guestData || null;
        
        if (!isValidOcrResponse(guestData)) {
          onFailure({ 
            message: literals['error.ocrInvalid']
          });
          return;
        }
        
        setVisible(false);
        aliceSuccessAction(guestData);
      })
      .catch(error => {
        onFailure(error?.response?.data);
      });
  }

  function onFailure(error) {
    console.error(error);
    notification.error({
      message: literals['error.genericTitle'],
      description: error?.message || literals['error.genericDesc'],
    });
    setLoading(false);
    setVisible(false);
  }

  console.log('Opening ocr scanner with params:', {
    allowedSources: mode,
    cameraType,
    documentType: documentCapturerType,
    country: nationality,
    language: selectedLanguage,
  });

  return (
    <div>
      {loading ? (
        <Loader></Loader>
      ) : (
        <OcrScanner
          allowedSources={mode}
          cameraType={cameraType}
          documentType={documentCapturerType}
          country={nationality}
          language={selectedLanguage}
          onComplete={onSuccess}
          onCancel={() => setVisible(false)}
        />
      )}
    </div>
  );
}

function getDocumentCapturerFromDocumentType(documentType) {
  // Info. PCD code: Alemania : pasaporte de niños

  const isIdCardType =
    documentType?.startsWith('ID') ||
    documentType?.startsWith('I<') ||
    documentType?.startsWith('CIITA') ||
    documentType?.startsWith('C<ITA') ||
    documentType?.startsWith('CPBRA') ||
    documentType?.startsWith('INCHL');
  const isPassportType = documentType?.startsWith('P<') || documentType?.startsWith('PCD');
  const isResidenceType = documentType?.startsWith('IR');
  const isDriverLicenseType = documentType?.startsWith('DL');
  const isHeardInsuranceType = documentType?.startsWith('HIC');
  const isMiDNI = documentType?.startsWith('MIDNI');
  const isMexChildQR = documentType === 'MEX-IDCHILD';

  if (isIdCardType) {
    return DOCUMENT_TYPES.IDCARD;
  } else if (isPassportType) {
    return DOCUMENT_TYPES.PASSPORT;
  } else if (isResidenceType) {
    return DOCUMENT_TYPES.RESIDENCEPERMIT;
  } else if (isDriverLicenseType) {
    return DOCUMENT_TYPES.DRIVERLICENSE;
  } else if (isHeardInsuranceType) {
    return DOCUMENT_TYPES.HEALTHINSURANCECARD;
  } else if (isMiDNI) {
    return DOCUMENT_TYPES.MIDNI;
  } else if (isMexChildQR) {
    return DOCUMENT_TYPES.MEX_IDCHILD;
  } else {
    return DOCUMENT_TYPES.PASSPORT;
  }
}